import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { CheckCircle, ArrowRight, Sparkles, PartyPopper } from 'lucide-react';
import UserLayout from '../components/UserLayout';
import './PaymentSuccess.css';

const PaymentSuccess = () => {
    const navigate = useNavigate();

    // Optionally add some confetti or celebratory logic here if desired

    return (
        <UserLayout>
            <div className="page-relative-wrapper">
                <div className="dashboard-container payment-success-page">
                    <div className="success-card">
                        <div className="celebration-icons">
                            <PartyPopper className="icon-pop-left" size={32} />
                            <div className="main-success-icon">
                                <CheckCircle size={80} color="#10b981" />
                            </div>
                            <Sparkles className="icon-pop-right" size={32} />
                        </div>
                        
                        <h1 className="success-header">Success!</h1>
                        <h2 className="success-subheader">Payment Successful!</h2>
                        
                        <div className="success-details">
                            <p>Thank you for subscribing. Your account has been upgraded and your premium features are now active.</p>
                            <div className="plan-badge">Premium Plan Active</div>
                        </div>

                        <div className="success-actions">
                            <Link to="/dashboard" className="primary-action-btn">
                                Go to Dashboard <ArrowRight size={18} />
                            </Link>
                            <Link to="/subscription" className="secondary-action-btn">
                                View Subscription Detail
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </UserLayout>
    );
};

export default PaymentSuccess;
